export default "__VITE_ASSET__BCO8aP9P__"